import { AbstractControl, ValidatorFn } from "@angular/forms";
import z from "zod";

export const createZodValidator = <Schema extends z.ZodTypeAny>(schema: Schema): ValidatorFn => {
	return (control: AbstractControl) => {
		const result = schema.safeParse(control.value);
		if (result.success) {
			return null;
		}
		const messages = result.error.issues.map((issue) => issue.message);
		return {
			zod: {
				message: messages[messages.length - 1] ?? "Invalid form value",
				messages,
			},
		};
	};
};
